export default __webpack_public_path__ + "static/media/1626.4b3312e1.png";